import { AgentInMemoryDatasource } from "@agent/data/datasources/agent-in-memory.datasource";
import { AgentDatasource } from "@agent/data/datasources/agent.datasource";
import type {
    Agent,
    AgentFilter,
    PathogenTypeEnum,
} from "@agent/domain/models/agent.model";
import type { AgentRepository } from "@agent/domain/repositories/agent.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import type { CheckboxOption } from "@core/domain/types/checkbox-option";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class AgentImplRepository implements AgentRepository {
    constructor(
        @inject(AgentDatasource)
        private readonly agentDatasource: AgentDatasource,
        @inject(AgentInMemoryDatasource)
        private readonly agentInMemoryDatasource: AgentInMemoryDatasource,
    ) {}

    getAll(agentFilter?: AgentFilter): ResultAsync<Agent[], FallbackError> {
        return this.agentDatasource.fetchAll(agentFilter);
    }

    pathogenTypeGetAll(): CheckboxOption<PathogenTypeEnum>[] {
        return this.agentInMemoryDatasource.fetchAllPathogenTypes();
    }
}
